/**
 * checked tasks becomes "checked: true"
 */

const P1_30 = {
  taskId: 'P1-30',
  headline: 'Pflegebedarf im Pflegetagebuch festhalten',
  copy: 'Ein Pflegetagebuch hilft Ihnen, den Bedarf an Unterstützung besser einzuschätzen.',
};

const tasks = [
  {
    taskId: 'P1-10',
    headline: 'Pflegebedürftigkeit erkennen',
    copy: ' Prüfen Sie, ob eine Pflegebedürftigkeit  besteht und ob weitere Schritte nötig sind.',
  },
  {
    taskId: 'P1-20',
    headline: 'Pflegebegriffe richtig verstehen',
    copy: 'Erfahren Sie mehr zu den wichtigsten Begriffen aus der Pflegewelt. Das Wissen hilft Ihnen bei der Finanzierung und Organisation der Pflege.',
  },
  P1_30,
  {
    taskId: 'P1-40',
    headline: 'Auf die neue Situation vorbereiten',
    subTasks: [
      {
        taskId: 'P1-40-10',
        headline: 'Wer kann die Pflege übernehmen?',
        copy: 'Suchen Sie das Gespräch mit Angehörigen, der Familie oder Freunden und besprechen Sie die Möglichkeiten.',
      },
      {
        taskId: 'P1-40-20',
        headline: 'Klären Sie, wo und wie die Pflege stattfinden wird',
        copy: 'Wie soll die Pflege gestaltet werden? Welche Möglichkeiten gibt es?',
      },
      {
        taskId: 'P1-40-30',
        headline: 'Betreuungsmodelle',
        copy: 'Besprechen Sie mit allen Beteiligten, wer die Pflege übernehmen kann und wie viel Zeit dafür zur Verfügung steht.',
      },
    ],
  },
  {
    taskId: 'P1-50',
    headline: 'Notwendige Dokumente erstellen',
    copy: 'Um die Pflege zu planen und zu organisieren, benötigen Sie verschiedene Dokumente, die wir Ihnen hier vorstellen.',
    subTasks: [
      {
        taskId: 'P1-50-10',
        headline: 'Pflegevertrag zwischen pflegenden Personen erstellen',
        copy: 'Planen Sie die Pflege mit mehreren Personen zu übernehmen, sollten Sie festhalten, wer für welche Aufgabe zuständig ist und wie Sie mit entstehenden Kosten und Leistungen umgehen.',
      },
      {
        taskId: 'P1-50-20',
        headline: 'Selbstbestimmt mit einer Patientenverfügung',
        copy: 'Mit einer Patientenverfügung bestimmen Sie die medizinische Versorgung, falls Sie sich selbst hierzu nicht mehr äußern können.',
      },
      {
        taskId: 'P1-50-30',
        headline: 'Die wichtigsten Vollmachten',
        copy: 'Vollmachten sind wichtige Dokumente für Ihre Vorsorge. Damit bestimmen Sie eine Person Ihres Vertrauens, die Sie an unterschiedlichen Stellen vertreten kann.',
      },
      {
        taskId: 'P1-50-40',
        headline: 'Notfallpass erstellen',
        copy: 'In einem Notfallpass oder der Notfallmappe sind die wichtigsten medizinischen Informationen zum Notfallpatienten, die Kontaktdaten von Angehörigen und andere hilfreiche Daten zusammengefasst.',
      },
      {
        taskId: 'P1-50-50',
        headline: 'Schwerbehindertenausweis beantragen',
        copy: 'Pflegebedürftigkeit und Schwerbehinderung sind nicht dasselbe, kommen aber oftmals zusammen vor. Prüfen Sie, ob bei Ihnen evtl. eine Schwerbehinderung vorliegt und erhalten Sie ggf. Nachteilsausgleiche.',
      },
    ],
  },
  {
    taskId: 'P1-60',
    headline: 'Pflege und Beruf organisieren',
    copy: 'Sollten Sie sich entscheiden, langfristig oder kurzfristig die Pflege Ihres Angehörigen zu übernehmen, suchen Sie das Gespräch mit Ihrem Arbeitgeber. Nutzen Sie die gesetzlichen Möglichkeiten, um sich eine Auszeit für die Pflege zu nehmen.',
  },
  {
    taskId: 'P1-70',
    headline: 'Leistungen ohne Pflegegrad',
    copy: 'Auch ohne Pflegegrad können Sie Leistungen und Hilfe erhalten. Die Krankenkasse kann Sie im Rahmen der Häusliche Krankenpflege unterstützen.',
  },
  {
    taskId: 'P1-80',
    headline: 'Einschätzung durch Pflegeberatung',
    copy: 'Die Situation von erfahrenen Pflegeberatern einschätzen lassen und gemeinsam einen Plan erstellen.',
  },
  {
    taskId: 'P2-10',
    headline: 'Pflegegrad prüfen',
    copy: 'Um Unterstützungsleistungen der Pflegekasse zu erhalten, benötigen Sie einen Pflegegrad.',
  },
  {
    taskId: 'P2-20',
    headline: 'Pflegegrad beantragen',
    copy: 'Liegt voraussichtlich ein Pflegegrad beziehungsweise ein höherer Pflegegrad vor, stellen Sie einen entsprechenden Antrag bei der zuständigen Pflegekasse.',
  },
  {
    taskId: 'P2-30',
    headline: 'Auf Begutachtungstermin vorbereiten',
    subTasks: [
      P1_30,
      {
        taskId: 'P2-30-20',
        headline: 'Rücksprache mit Ärzten halten und Atteste besorgen',
        copy: 'Organisieren Sie sich schriftliche Nachweise von Ihrem Arzt. Diese können Sie bei der Pflegebegutachtung vorzeigen.',
      },
      {
        taskId: 'P2-30-30',
        headline: 'Schwerbehinderung klären und beantragen',
        copy: 'Pflegebedürftigkeit und Schwerbehinderung sind nicht dasselbe, aber kommen oftmals zusammen vor. Menschen mit ausgewiesener Schwerbehinderung erhalten Nachteilsausgleiche.',
      },
      {
        taskId: 'P2-30-40',
        headline: 'Begutachtungstermin wahrnehmen',
        copy: 'Bei der Pflegebegutachtung kommt ein Gutachter zum Antragsteller nach Hause. Nur in Ausnahmesituationen ist eine Begutachtung nach Aktenlage möglich. Die Begutachtung dauert in der Regel 60 Minuten.',
      },
    ],
  },
  {
    taskId: 'P2-40',
    headline: 'Anerkannten Pflegegrad eintragen',
    copy: 'Der Gutachter gibt seine Empfehlung an die Pflegekasse weiter. Die Pflegeversicherung entscheidet dann, welcher Pflegegrad anerkannt wird und schickt Ihnen einen Bescheid. Tragen Sie hier den Pflegegrad aus Ihrem Bescheid ein.',
  },
  {
    taskId: 'P2-50',
    headline: 'Notwendigkeit für einen Widerspruch prüfen',
    copy: 'Wenn Sie mit dem Ergebnis der Pflegekasse nicht einverstanden sind, haben Sie vier Wochen Zeit, um Widerspruch einzulegen.',
  },
  {
    taskId: 'P2-60',
    headline: 'Widerspruch einlegen',
    copy: 'Sie möchten dem Pflegegrad-Bescheid widersprechen. Dafür setzen Sie ein formloses Schreiben auf oder nutzen unsere Vorlage.',
  },
  {
    taskId: 'P2-70',
    headline: 'Widerspruch-Ergebnis eintragen',
    copy: 'Zu welchem Ergebnis ist die Pflegekasse nach dem Widerspruch gekommen? Tragen Sie hier ein, welcher Pflegegrad anerkannt wurde.',
  },
  {
    taskId: 'P3-10',
    headline: 'Pflegeleistungen einfach erklärt',
    copy: 'Gute Pflege kostet Geld. Wenn Sie wissen, welche Leistungen aus der Pflegeversicherung Ihnen zustehen, können Sie am richtigen Ende Geld sparen.',
    subTasks: [
      {
        taskId: 'P3-10-10',
        headline: 'Ihnen zustehende Leistungen ansehen',
        copy: 'Wer einen Pflegegrad hat, hat Anspruch auf Pflegeleistungen. Wir geben Ihnen einen Überblick zu den Leistungen der Pflegeversicherung.',
      },
      {
        taskId: 'P3-10-20',
        headline: 'Leistungen ansehen, die Wohnort-abhängig sind',
      },
    ],
  },
  {
    taskId: 'P3-20',
    headline: 'Pflegeleistungen bestmöglich nutzen',
    copy: 'Wer sich mit Pflegeleistungen und den Kombinationsmöglichkeiten auskennt, kann die Leistungen der Pflegeversicherung auf seine eigene Bedürfnisse anpassen und bestmöglich nutzen.',
  },
  {
    taskId: 'P3-30',
    headline: 'Spezifische Pflegeleistungen beantragen',
    copy: 'Um neben Pflegegeld oder Pflegesachleistungen weitere Leistungen der Pflegeversicherung zu erhalten, sind Anträge notwendig.',
  },
  {
    taskId: 'P4-10',
    headline: 'Weitere Kosten sparen',
    copy: 'Mit den Leistungen der Pflegeversicherung können Sie die Pflege zuhause finanzieren. Es gibt weitere Möglichkeiten, wie Sie Kosten sparen können.',
    subTasks: [
      {
        taskId: 'P4-10-10',
        headline: 'Rundfunkbeitrag: Ermäßigung oder Befreiung prüfen',
        copy: 'Es gibt Voraussetzungen, mit denen Sie keinen oder nur noch einen ermäßigten Rundfunkbeitrag zahlen müssen.',
      },
      {
        taskId: 'P4-10-20',
        headline: 'Wenn das Geld für die Pflege nicht ausreicht',
        copy: 'Wer für eigene Pflegekosten nicht aufkommen kann, für den sind "Hilfe zur Pflege" und "Elternunterhalt" wichtige Begriffe.',
      },
      {
        taskId: 'P4-10-30',
        headline: 'Kostenübernahme für Krankentransporte prüfen',
        copy: 'Ein Krankentransport wird verordnet, wenn Ihre Mobilität durch Krankheit oder Unfall eingeschränkt ist, Sie medizinische oder fachliche Betreuung benötigen und die Fahrt aus medizinischer Sicht notwendig ist.',
      },
      {
        taskId: 'P4-10-40',
        headline: 'Stromkostenerstattung für elektrische Hilfsmittel prüfen',
        copy: 'Für elektrisch betriebene Hilfsmittel, die vom Arzt verschrieben und von Ihrer Kranken- oder Pflegekasse bewilligt wurden, übernimmt die Kasse auch die Stromkosten für den Betrieb.',
      },
      {
        taskId: 'P4-10-50',
        headline: 'Pflegekosten von der Steuer absetzen',
        copy: 'Verschiedene Ausgaben, die in Verbindung mit der Pflege stehen, sind steuerlich absetzbar. Grundsätzlich lassen sich Pflegekosten als außergewöhnliche Belastung oder als haushaltsnahe Dienstleistung geltend machen.',
      },
    ],
  },
  {
    taskId: 'P4-20',
    headline: 'Pflegebedürftigkeit nimmt zu',
    copy: 'Die Verschlechterung des Gesundheitszustandes führt meist auch dazu, dass mehr Hilfe und Unterstützung im Alltag benötigt wird.',
  },
  {
    taskId: 'P4-30',
    headline: 'Auf Beratungseinsatz vorbereiten',
    copy: 'Wenn Sie Pflegegeld erhalten, müssen Sie regelmäßig an kostenfreien Beratungseinsätzen teilnehmen. Ansonsten kann das Pflegegeld gekürzt oder ganz gestrichen werden.',
  },
];

export default tasks;
